import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { PickDropCustomer } from '../business-entities/pick-drop-customer';
import { CustomerDropPickService } from '../data-services/customer-drop-pick.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerPickDropService {
  customerPickDropList: PickDropCustomer[];
  filterTypeId: number = 0;
  dealerId:string = '';
  constructor(private service : CustomerDropPickService) { }

  async getCustomerCustomerPickDrop(data):Promise<any>{
    await this.service.getCustomerPickDropList(data).then(
      (res:GenericResponse<Array<PickDropCustomer>>)=>{
        this.customerPickDropList = res.responseObject;
      }
    );
    return this.customerPickDropList;
  }
}
